module.exports = __webpack_public_path__ + "img/gzh.588bb7cf.png";